export default "__VITE_ASSET__BZaq1y0C__"